export const actionCodeSettings = {
  url: 'https://praxis-bulkamp2.vercel.app/myaccount/account-verified',
  handleCodeInApp: true,
}
